import { render, staticRenderFns } from "./anKangWx.vue?vue&type=template&id=210788f3&scoped=true&"
import script from "./anKangWx.vue?vue&type=script&lang=js&"
export * from "./anKangWx.vue?vue&type=script&lang=js&"
import style0 from "./anKangWx.vue?vue&type=style&index=0&id=210788f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210788f3",
  null
  
)

export default component.exports